import { useEffect } from 'react';
import { parseDeepLink, storePartnerHash, getStoredPartnerHash } from '@/lib/deep-link';
import { useNavigate } from 'react-router-dom';
import { httpClient } from '@/api/http-client';

export function useDeepLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleDeepLink = () => {
      const url = window.location.href;
      const params = parseDeepLink(url);

      if (params?.partner) {
        storePartnerHash(params.partner);

        // Se não for a rota de redirecionamento /p/:hash, registra o clique diretamente no backend
        if (!url.includes('/p/')) {
          const sessionTrackKey = `medikei_tracked_click_${params.partner}`;
          if (typeof window !== 'undefined' && !sessionStorage.getItem(sessionTrackKey)) {
            sessionStorage.setItem(sessionTrackKey, 'true');
            httpClient.post('/tracking/click', {
              slug: params.partner,
              source: 'DEEP_LINK',
              landingUrl: window.location.href,
              referrerUrl: document.referrer || undefined,
            }).catch((err) => {
              console.debug('Deep link click tracked locally:', err);
            });
          }
        }
      }
    };

    const storedHash = getStoredPartnerHash();
    if (storedHash && typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const urlPartner = urlParams.get('partner');

      if (urlPartner && urlPartner !== storedHash) {
        storePartnerHash(urlPartner);
      }
    }

    handleDeepLink();

    window.addEventListener('popstate', handleDeepLink);

    return () => {
      window.removeEventListener('popstate', handleDeepLink);
    };
  }, [navigate]);
}

export function DeepLinkHandler() {
  useDeepLinkHandler();
  return null;
}
